import { render, staticRenderFns } from "./x-icon.vue?vue&type=template&id=5cbf8199"
import script from "./x-icon.ts?vue&type=script&lang=js&external"
export * from "./x-icon.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports